import React, { useState, useEffect } from "react";
import Layout from "../../components/Layout/Layout";
import UserServices from "./../../services/UserServices";
import RoleServices from "./../../services/RoleServices";
import fire from "./../../utils/Toastr";
import BackButton from "../../components/BackButton";

export default function UserUpdate() {
  const [user, setUser] = useState({});
  const [role, setRole] = useState([]);
  const errors = {
    userNameIsValidated: false,
    userError: "",
    firstNameIsValidated: false,
    firstNameError: "",
    lastNameIsValidated: "",
    lastNameError: "",
    formIsSubmitting: false,
  };
  const [formState, setFormState] = useState(errors);
  const [formValue, setFormValues] = useState({
    userName: "",
    roleId: 0,
    adminType: "",
    firstName: "",
    region: "",
    roleName: "",
    surname: "",
  });

  const name = new URLSearchParams(window.location.search).get("id");
  const viewUser = async () => {
    const resp = await UserServices.viewDetails(name);
    if (resp) {
      setUser(resp.data);
      setFormValues({
        ...formValue,
        adminType: resp.data.adminType,
        roleName: resp.data.roleName,
        region: resp.data.region,
        firstName: resp.data.firstName,
        surname: resp.data.surname,
        roleId: resp.data.roleId,
        userName: resp.data.userName,
      });
    }
  };
  const formValidation = {
    userNameHandler: (event) => {
      setFormValues({ ...formValue, userName: event.target.value });
      if (event.target.value.trim().length < 1) {
        setFormState({
          ...formState,
          userError: "Username cannot be empty",
          userNameIsValidated: false,
        });
        return;
      }
      if (/^[1-9][0-9]*$/.test(event.target.value)) {
        setFormState({
          ...formState,
          userError: "Enter a valid username",
          userNameIsValidated: false,
        });
        return;
      }
      setFormState({
        ...formState,
        userError: "",
        userNameIsValidated: true,
      });
    },
    firstNameHandler: (event) => {
      setFormValues({ ...formValue, firstName: event.target.value });
      if (event.target.value.trim().length < 1) {
        setFormState({
          ...formState,
          firstNameError: "First name cannot be empty",
          firstNameIsValidated: false,
        });
        return;
      }
      if (/^[1-9][0-9]*$/.test(event.target.value)) {
        setFormState({
          ...formState,
          firstNameError: "Enter a valid name",
          firstNameIsValidated: false,
        });
        return;
      }
      setFormState({
        ...formState,
        firstNameError: "",
        firstNameIsValidated: true,
      });
    },
    lastNameHandler: (event) => {
      setFormValues({ ...formValue, lastName: event.target.value });
      if (event.target.value.trim().length < 1) {
        setFormState({
          ...formState,
          lastNameError: "Last name cannot be empty",
          lastNameIsValidated: false,
        });
        return;
      }
      if (/^[1-9][0-9]*$/.test(event.target.value)) {
        setFormState({
          ...formState,
          lastNameError: "Enter a valid name",
          lastNameIsValidated: false,
        });
        return;
      }
      setFormState({
        ...formState,
        lastNameError: "",
        lastNameIsValidated: true,
      });
    },
    regionHandler: (event) => {
      setFormValues({ ...formValue, region: event.target.value });
    },
    roleHandler: (event) => {
      const roles = role.find((x) => x.roleName === event.target.value);
      setFormValues({
        ...formValue,
        roleName: event.target.value,
        roleId: roles.id,
      });
    },
    adminHandler: (event) => {
      setFormValues({ ...formValue, adminType: event.target.value });
    },
  };
  const roles = async () => {
    const listRoles = await RoleServices.listRoles(1, 10, "");
    setRole([...listRoles.data.result]);
  };
  const editUser = async (e) => {
    e.preventDefault();
    const resp = await UserServices.editUser({
      userName: user.userName,
      roleId: formValue.roleId,
      adminType: formValue.adminType,
      firstName: formValue.firstName,
      region: formValue.region,
      roleName: formValue.roleName,
      surname: formValue.surname,
    });
    if (resp) {
      fire("success", resp.message);
      setTimeout(() => {
        window.location.href = "/users";
      }, 5000);
    }
  };
  const clear = (e) => {
    e.preventDefault();
    window.location.reload(true);
  };
  useEffect(() => {
    viewUser();
    roles();
  }, []);
  return (
    <>
      <Layout title="Update User" pageTag={"admin"} current={"/update/user"}>
        <React.Fragment>
          <main>
            <div className="max-w-7xl mx-auto">
              <BackButton />
            </div>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
              <div className="py-4">
                <div className="flex justify-center">
                  <h4 className="font-bold">
                    {user.surname} {user.firstName}
                  </h4>
                </div>
                <div className="px-4 sm:px-6 lg:px-8">
                  <div className="mt-8 flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-zinc-200">
                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg bg-white mt-5">
                          <div className="">
                            <div className="inline block min-w-full py-2 align-middle md:px-6 lg:px-8 bg-white">
                              {/* form */}
                              <form className="px-6">
                                <div className="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="firstName"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      First name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        onChange={
                                          formValidation.firstNameHandler
                                        }
                                        value={formValue.firstName}
                                        name="firstName"
                                        id="firstName"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="surname"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Last name
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        onChange={
                                          formValidation.lastNameHandler
                                        }
                                        value={formValue.surname}
                                        name="surname"
                                        id="surname"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="surname"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Username
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        onChange={
                                          formValidation.userNameHandler
                                        }
                                        value={formValue.userName}
                                        name="surname"
                                        id="surname"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                  <div className="sm:col-span-3">
                                    <label
                                      htmlFor="email"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Email
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="email"
                                        defaultValue={user.emailAddress}
                                        disabled
                                        name="email"
                                        id="email"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>

                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="roleName"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Role
                                    </label>
                                    <div className="mt-1">
                                      <select
                                        placeholder="Select role"
                                        id="role"
                                        name="role"
                                        onChange={formValidation.roleHandler}
                                        value={formValue.roleName}
                                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                      >
                                        <option value="">
                                          {formValue.roleName}
                                        </option>
                                        {role.map((item, i) => (
                                          <option key={i} value={item.roleId}>
                                            {item.roleName}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>

                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="role"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Admin Type
                                    </label>
                                    <div className="mt-1">
                                      <select
                                        placeholder="Select role"
                                        id="role"
                                        name="role"
                                        onChange={formValidation.adminHandler}
                                        value={formValue.adminType}
                                        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                      >
                                        <option value="">
                                          Select admin type
                                        </option>
                                        <option value="Maker">Maker</option>
                                        <option value="Checker">Checker</option>
                                      </select>
                                    </div>
                                  </div>
                                  <div className="sm:col-span-2">
                                    <label
                                      htmlFor="region"
                                      className="block text-sm font-medium text-gray-700"
                                    >
                                      Region
                                    </label>
                                    <div className="mt-1">
                                      <input
                                        type="text"
                                        onChange={formValidation.regionHandler}
                                        value={formValue.region}
                                        name="region"
                                        id="region"
                                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="mt-4 flex justify-end">
                                  <button
                                    type="submit"
                                    onClick={clear}
                                    className="btn-sec focus:text-white hover:text-white active:text-white mr-2 bg-gray-100 text-gray-900 inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium  shadow-sm sm:w-auto"
                                  >
                                    Reset
                                  </button>
                                  <button
                                    type="submit"
                                    onClick={editUser}
                                    className="btn-primary inline-flex items-center rounded-md border border-trasnparent px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                                  >
                                    Save Changes
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </React.Fragment>
      </Layout>
    </>
  );
}
